import React from "react";
import { Modal } from "react-bootstrap";

const TalkToUs = (props) => {
  const { show, onHide, closeButton, size, children, backdrop } = props;
  return (
    <Modal
      scrollable={false}
      size={size}
      centered
      backdrop={backdrop}
      keyboard={false}
      show={show}
      onHide={onHide}
      className="custom-modal"
    >
      <Modal.Header className="border-0" closeButton={closeButton}>
        <Modal.Title className="font-weight-normal fs-2">
          Talk to us
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default TalkToUs;
